import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Switch} from "react-router";
import {Route} from "react-router-dom";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import ListNew from "./ListNew";
import ListView from "./ListView";
import ContactList from "./ContactList";

class ContactLists extends Component {
  render() {
    return <React.Fragment>
      <Helmet>
        <title>Contact Lists</title>
      </Helmet>
      <Route exact path="/settings/contact-lists" component={ListView}/>
      <Switch>
        <Route path="/settings/contact-lists/new" component={ListNew}/>
        <Route path="/settings/contact-lists/:listId" component={ContactList}/>
      </Switch>
    </React.Fragment>;
  }
}

export default withBreadcrumb(
  { title: 'Contact Lists', path: '/settings/contact-lists' },
  ContactLists
)




// WEBPACK FOOTER //
// ./src/components/Settings/ContactLists/ContactLists.js